"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var reactHelpers_1 = require("../utils/reactHelpers");
var preparePropertyFor = function (property, propertyDirection, p) {
    if (p[property] || p[property] === 0) {
        return p[property] * parseFloat(p.theme.SizeSpacingDefault) + "rem";
    }
    if (p[propertyDirection] || p[propertyDirection] === 0) {
        return p[propertyDirection] * parseFloat(p.theme.SizeSpacingDefault) + "rem";
    }
    return '';
};
var prepareBreakpointPropertyFor = function (property, propertyShortHand, p) {
    var breakPointsMap = {
        xs: "@media (min-width: " + parseInt(p.theme.SizeBreakpointsXs, 10) + "px) and (max-width: " + (parseInt(p.theme.SizeBreakpointsS, 10) - 1) + "px)",
        s: "@media (min-width: " + parseInt(p.theme.SizeBreakpointsS, 10) + "px) and (max-width: " + (parseInt(p.theme.SizeBreakpointsM, 10) - 1) + "px)",
        m: "@media (min-width: " + parseInt(p.theme.SizeBreakpointsM, 10) + "px) and (max-width: " + (parseInt(p.theme.SizeBreakpointsL, 10) - 1) + "px)",
        l: "@media (min-width: " + parseInt(p.theme.SizeBreakpointsL, 10) + "px) and (max-width: " + (parseInt(p.theme.SizeBreakpointsXl, 10) - 1) + "px)",
        xl: "@media (min-width: " + parseInt(p.theme.SizeBreakpointsXl, 10) + "px)"
    };
    var propertyCss = '';
    Object.keys(breakPointsMap).forEach(function (breakPoint) {
        var propertyPassed = p[breakPoint + "-" + propertyShortHand];
        if (Number.isFinite(propertyPassed)) {
            propertyCss = propertyCss + "\n        " + breakPointsMap[breakPoint] + " {\n          " + property + " : " + propertyPassed * parseFloat(p.theme.SizeSpacingDefault) + "rem\n        }\n      ";
        }
    });
    return propertyCss;
};
var BoxSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n\n  padding: ", ";\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n\n\n"], ["\n  margin: ",
    ";\n\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n\n  padding: ",
    ";\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  ",
    "\n  ",
    "\n  ",
    "\n  ",
    "\n\n  ",
    "\n  ",
    "\n  ",
    "\n  ",
    "\n\n\n"])), function (p) {
    return p.m || p.m === 0 ? p.m * parseFloat(p.theme.SizeSpacingDefault) + "rem" : '';
}, function (props) { return preparePropertyFor('mt', 'my', props); }, function (props) { return preparePropertyFor('mr', 'mx', props); }, function (props) { return preparePropertyFor('mb', 'my', props); }, function (props) { return preparePropertyFor('ml', 'mx', props); }, function (p) {
    return p.p || p.p === 0 ? p.p * parseFloat(p.theme.SizeSpacingDefault) + "rem" : '';
}, function (props) { return preparePropertyFor('pt', 'py', props); }, function (props) { return preparePropertyFor('pr', 'px', props); }, function (props) { return preparePropertyFor('pb', 'py', props); }, function (props) { return preparePropertyFor('pl', 'px', props); }, function (props) {
    return prepareBreakpointPropertyFor('margin-top', 'mt', props);
}, function (props) {
    return prepareBreakpointPropertyFor('margin-right', 'mr', props);
}, function (props) {
    return prepareBreakpointPropertyFor('margin-bottom', 'mb', props);
}, function (props) {
    return prepareBreakpointPropertyFor('margin-left', 'ml', props);
}, function (props) {
    return prepareBreakpointPropertyFor('padding-top', 'pt', props);
}, function (props) {
    return prepareBreakpointPropertyFor('padding-right', 'pr', props);
}, function (props) {
    return prepareBreakpointPropertyFor('padding-bottom', 'pb', props);
}, function (props) {
    return prepareBreakpointPropertyFor('padding-left', 'pl', props);
});
var Box = function (props) {
    var children = props.children, forwardedRef = props.forwardedRef, rest = __rest(props, ["children", "forwardedRef"]);
    return (react_1.default.createElement(BoxSC, __assign({}, rest, { ref: forwardedRef }), children));
};
exports.BoxRootComp = Box;
Box.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.node]),
    forwardedRef: prop_types_1.default.any,
    m: prop_types_1.default.number,
    mt: prop_types_1.default.number,
    mr: prop_types_1.default.number,
    mb: prop_types_1.default.number,
    ml: prop_types_1.default.number,
    mx: prop_types_1.default.number,
    my: prop_types_1.default.number,
    p: prop_types_1.default.number,
    pt: prop_types_1.default.number,
    pr: prop_types_1.default.number,
    pb: prop_types_1.default.number,
    pl: prop_types_1.default.number,
    px: prop_types_1.default.number,
    py: prop_types_1.default.number,
    'BREAKPOINT-PROPERTY': prop_types_1.default.string,
    className: prop_types_1.default.string
};
Box.defaultProps = {
    children: null,
    forwardedRef: null,
    m: undefined,
    mt: undefined,
    mr: undefined,
    mb: undefined,
    ml: undefined,
    mx: undefined,
    my: undefined,
    p: undefined,
    pt: undefined,
    pr: undefined,
    pb: undefined,
    pl: undefined,
    px: undefined,
    py: undefined,
    className: undefined
};
exports.default = reactHelpers_1.withForwardedRef(Box);
var templateObject_1;
//# sourceMappingURL=Box.js.map